export default "__VITE_ASSET__H0mDhMiG__"